import { serverDateToJSDate } from "digiwash-core";
import dayjs from "dayjs";
import { formatNumber } from "digiwash-core";
import { Order, OrderLatestStatus } from "../../types/server";

export { generateDescriptionByStatus, generateColorByStatus };

function generateDescriptionByStatus(order: Order) {
  let collectionDate = order?.collection?.period?.date
    ? formatNumber(
        dayjs(serverDateToJSDate(order.collection.period.date)).format(
          "D MMMM YY"
        )
      )
    : "";
  let deliveryDate = order?.delivery?.period?.date
    ? formatNumber(
        dayjs(serverDateToJSDate(order.delivery.period.date)).format(
          "D MMMM YY"
        )
      )
    : "";

  switch (order.latest_status) {
    case OrderLatestStatus.CanceledByCustomer:
    case OrderLatestStatus.CanceledBySystem:
      return {
        title: "سفارش شما لغو شد.",
        description: "سفارش به درخواست شما لغو شد.",
      };
    case OrderLatestStatus.Collected:
      return {
        title: "سفارش شما جمع‌آوری شده است.",
        description: `مراجعه در ${collectionDate}`,
      };
    case OrderLatestStatus.CollectionCanceled:
      return {
        title: "جمع‌آوری سفارش کنسل شد.",
        description: `مراجعه در ${collectionDate}`,
      };
    case OrderLatestStatus.CollectionNotPresent:
      return {
        title: "هنگام جمع‌آوری حضور نداشتید",
        description: `مراجعه در ${collectionDate}`,
      };
    case OrderLatestStatus.DeliveryNotPresent:
      return {
        title: "هنگام تحویل حضور نداشتید",
        description: `مراجعه در ${deliveryDate}`,
      };
    case OrderLatestStatus.DeliveryCanceled:
      return {
        title: "تحویل سفارش شما کنسل شد.",
        description: `مراجعه در ${deliveryDate}`,
      };
    case OrderLatestStatus.InProgress:
      return {
        title: "سفارش شما در حال انجام است.",
        description: "پس از آماده شدن سفارش پیامک دریافت خواهید کرد.",
      };
    case OrderLatestStatus.ReadyToCollect:
      return {
        title: "در انتظار سفیر برای جمع‌آوری",
        description: `مراجعه در ${collectionDate}`,
      };
    case OrderLatestStatus.ReadyToDeliver:
      return {
        title: "در انتظار تحویل سفارش توسط سفیر",
        description: `مراجعه در ${deliveryDate}`,
      };
    case OrderLatestStatus.Unwrapped:
      return {
        title: "سفارش شما در کارخانه می‌باشد",
        description: "",
      };
    case OrderLatestStatus.WorkDone:
      return {
        title: "سفارش شما آماده تحویل است.",
        description: "زمان تحویل را مشخص کنید.",
      };
    case OrderLatestStatus.Delivered:
      return {
        title: "سفارش با موفقیت اتمام رسید.",
        description: `مراجعه در ${deliveryDate}`,
      };
    case OrderLatestStatus.SubmittedByCustomer:
    case OrderLatestStatus.SubmittedByCRM:
      return {
        title: "سبد خرید",
        description: "",
      };
    default:
      return {
        title: "نامشخص",
        description: "",
      };
  }
}

function generateColorByStatus(order: Order) {
  function generateCardColor() {
    if (
      [
        OrderLatestStatus.CanceledByCustomer,
        OrderLatestStatus.CanceledBySystem,
      ].includes(order.latest_status)
    ) {
      return "neutrals.250";
    }

    if ([OrderLatestStatus.Delivered].includes(order.latest_status)) {
      return "green.light500";
    }

    return "primary.light940";
  }

  function generateTextColor() {
    if (
      [
        OrderLatestStatus.CanceledByCustomer,
        OrderLatestStatus.CanceledBySystem,
      ].includes(order.latest_status)
    ) {
      return {
        main: "red.main",
        description: "red.main",
      };
    }

    if ([OrderLatestStatus.Delivered].includes(order.latest_status)) {
      return {
        main: "green.main",
        description: "green.main",
      };
    }

    return {
      main: "common.black",
      description: "neutrals.800",
    };
  }

  return {
    cardColor: generateCardColor(),
    textColor: generateTextColor(),
  };
}
